<button id="customersButton" routerLink="/customers">Customers</button>
<div>
  <button id="loginButton" *ngIf="!(authService.authState$ | async)?.isAuthenticated" (click)="oktaAuth.signInWithRedirect()">Login</button>
  <button id="logoutButton" *ngIf="(authService.authState$ | async)?.isAuthenticated" (click)="oktaAuth.signOut()">Logout</button>
</div>
